

import config from "../Context/Config"; // Adjust the path based on your project
import { showSwal } from "./swal";
import { handleApiError } from "./error";

export const autosave = async (chart, apptId, localpatientid, form_type, data, tryRefresh) => {
    try {
        const departmentData = JSON.parse(localStorage.getItem("selectedLocation"));

        const response = await fetch(`${config.API_BASE_URL}/auto_save`, {
            method: "POST",
            headers: {
                action_id: config.ACTIONID["edit"],
                "Content-Type": "application/json",
                Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                "practice": localStorage.getItem("digital-form-dept-practice")
            },
            body: JSON.stringify({
                entID: chart,
                apptId: apptId,
                chart: localpatientid,
                form_type: form_type,
                form: data,
                practice: `${localStorage.getItem("digital-form-dept-practice")}`,
                dept_id: departmentData.id,
            }),
        });

        if (response.ok) {
            const data = await response.json();
            if (data === "code not found") {
                return false;
            }
            return true;
        }

        await handleApiError(response.status, async () => {
            // Retry original call after refresh
            return await autosave(chart, apptId, localpatientid, form_type, data);
        }, tryRefresh);

    } catch (error) {
        showSwal("error", "Network Error", "Unable to connect to server. Please try again later.");
    }
};
